import React, { useEffect, useRef, useState } from "react";

let googleMapsLoaded = false;

export function LocationInput({ value, onChange }) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [inputValue, setInputValue] = useState(value);

  const [isApiAvailable, setIsApiAvailable] = useState(true);

  useEffect(
    () => {
      setInputValue(value);
    },
    [value]
  );

  useEffect(
    () => {
      const apiKey = process.env.REACT_APP_GOOGLEMAP_API;

      if (!apiKey) {
        console.warn("Google Maps API key not found");
        setIsApiAvailable(false);
        onChange("Austin, Texas", 24.8607, 67.0011);
        return;
      }

      const initAutocomplete = () => {
        if (!inputRef.current || !window.google) return;

        try {
          autocompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            { types: ["(cities)"] }
          );

          autocompleteRef.current.addListener("place_changed", () => {
            const place = autocompleteRef.current.getPlace();
            if (place && place.geometry && place.geometry.location) {
              const formattedAddress = place.formatted_address || "";
              onChange(formattedAddress);
            }
          });
        } catch (error) {
          console.error("Failed to initialize Google Maps:", error);
          setIsApiAvailable(false);
          onChange("Karachi, Pakistan");
        }
      };

      window.initializeAutocomplete = initAutocomplete;

      if (!googleMapsLoaded) {
        googleMapsLoaded = true;
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initializeAutocomplete`;
        script.async = true;
        script.defer = true;

        script.onerror = () => {
          console.error("Failed to load Google Maps script");
          setIsApiAvailable(false);
          onChange("Karachi, Pakistan");
          googleMapsLoaded = false;
        };

        document.head.appendChild(script);
      } else if (
        window.google &&
        window.google.maps &&
        window.google.maps.places
      ) {
        initAutocomplete();
      }

      return () => {
        if (autocompleteRef.current && window.google?.maps?.event) {
          window.google.maps.event.clearInstanceListeners(
            autocompleteRef.current
          );
        }
      };
    },
    [onChange]
  );
  const handleInputChange = e => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (!autocompleteRef.current) {
      onChange(newValue);
    }
  };

  return (
    <div className="relative">
      <input
        ref={inputRef}
        id="venue"
        name="venue"
        value={inputValue}
        placeholder="Venue*"
        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent pr-10 cursor-pointer"
        required
        onChange={handleInputChange}
        readOnly={!isApiAvailable}
        onClick={() => {
          if (!isApiAvailable) {
            alert("Google Maps API not available. Using default location.");
          }
        }}
      />
    </div>
  );
}
